module.exports = __webpack_public_path__ + "img/sports_thumbnail.9fb6b2f6.jpg";